import {
  Tabs,
  DatePicker,
  TabPane,
  Select,
  Option,
  Input,
  Dialog,
  Table,
  TableColumn,
  Icon,
  Steps,
  Step,
  Popover,
  Tooltip,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Progress,
  Form,
  FormItem,
  Statistic,
  Tree,
  Pagination,
  Empty,
  Button,
  Carousel,
  CarouselItem,
} from "element-ui";
const elementComponents = {
  install: function (Vue) {
    Vue.component(Tabs.name, Tabs);
    Vue.component(Empty.name, Empty);
    Vue.component(DatePicker.name, DatePicker);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Select.name, Select);
    Vue.component(Option.name, Option);
    Vue.component(Input.name, Input);
    Vue.component(Dialog.name, Dialog);
    Vue.component(Table.name, Table);
    Vue.component(TableColumn.name, TableColumn);
    Vue.component(Icon.name, Icon);
    Vue.component(Steps.name, Steps);
    Vue.component(Step.name, Step);
    Vue.component(Popover.name, Popover);
    Vue.component(Tooltip.name, Tooltip);
    Vue.component(Row.name, Row);
    Vue.component(Col.name, Col);
    Vue.component(Collapse.name, Collapse);
    Vue.component(CollapseItem.name, CollapseItem);
    Vue.component(Progress.name, Progress);
    Vue.component(Form.name, Form);
    Vue.component(FormItem.name, FormItem);
    Vue.component(Statistic.name, Statistic);
    Vue.component(Tree.name, Tree);
    Vue.component(Pagination.name, Pagination);
    Vue.component(Button.name, Button);
    Vue.component(Carousel.name, Carousel);
    Vue.component(CarouselItem.name, CarouselItem);
  },
};
export default elementComponents;
